import React from 'react';
import moment from "moment";
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import CChart from 'components/CChart';
import ToolbarDate from '../ToolbarDate';

import {
    Input, Button, Col
} from "reactstrap";


export default function ChartFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, accessList } = props;//parentDisabled

    const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues } = formManager;


    const [shouldRender, setShouldRender] = React.useState(false);
    const [altData, setAltData] = React.useState({ labels: [], datasets: [] });
    const [refreshData, setRefreshData] = React.useState(false);
    const [selectFilter, setSelectFilter] = React.useState(null);

    const [curDate, setCurDate] = React.useState(data.argumentsObj?.toolbarDateConfig ? moment().format() : null);
    const [minDate, setMinDate] = React.useState(modelFctManager.toolbarArgs?.date ? commonFunc.getStartDate(moment(modelFctManager.toolbarArgs.date), modelFctManager.toolbarArgs.period) : null);
    const [maxDate, setMaxDate] = React.useState(modelFctManager.toolbarArgs?.date ? commonFunc.getEndDate(moment(modelFctManager.toolbarArgs.date), modelFctManager.toolbarArgs.period) : null);
    const [curPeriod, setCurPeriod] = React.useState(data.argumentsObj?.toolbarDateConfig?.period || "L");

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        var srcArgs = data.argumentsObj?.loadObj;
        if (!(srcArgs && Object.keys(srcArgs).length && srcArgs.url) && srcArgs?.cacheTarget) modelFctManager.addConnectedCache(data, srcArgs?.cacheTarget);

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);

    React.useEffect(() => {
        if (modelFctManager.toolbarArgs?.date && moment(modelFctManager.toolbarArgs?.date).toDate().getTime() !== moment(curDate).toDate().getTime()) {
            setCurDate(new Date(modelFctManager.toolbarArgs?.date));
            setAltData({ labels: [], datasets: [] });
            setSelectFilter(null);

            if (modelFctManager.toolbarArgs) {
                //console.debug(modelFctManager.toolbarArgs.date);
                //console.debug(modelFctManager.toolbarArgs.period);

                var curMoment = moment(modelFctManager.toolbarArgs.date);
                if (data.argumentsObj?.toolbarDateConfig?.useMinDate === "parent") setMinDate(commonFunc.getStartDate(curMoment, modelFctManager.toolbarArgs.period));
                else {
                    //TODO : value spec
                }
                if (data.argumentsObj?.toolbarDateConfig?.useMaxDate === "parent") setMaxDate(commonFunc.getEndDate(curMoment, modelFctManager.toolbarArgs.period));
                else {
                    //TODO : value spec
                }

            }
        }
    }, [modelFctManager.toolbarArgs?.date]);

    React.useEffect(() => {
        if (curDate) {
            updateData();
        }
    }, [curDate, selectFilter]);


    React.useEffect(() => {
        updateData();
    }, [refreshData]);

    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.setValue = (rows) => { loadData(rows); };
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.refreshFromCache = () => { setRefreshData(!refreshData) };

    /*const { ref: refElem, ...restElem } =*/ register(bindPropResult);

    //var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    var fullHeight = false;
    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { width: "100%", height: "250px" };
    var frameClass = "";
    var frameStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    function updateData() {
        var srcArgs = data.argumentsObj?.loadObj;
        var args = {};
        if (srcArgs && Object.keys(srcArgs).length && srcArgs.url) {
            Object.keys(srcArgs).forEach((key) => {
                var valueArgs = srcArgs[key];
                if (valueArgs?.startsWith) {
                    if (valueArgs.startsWith("prop:")) args[key] = (accessList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                    else if (valueArgs.startsWith("value:")) args[key] = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                    else if (valueArgs === "curDate") args[key] = curDate;
                    else args[key] = valueArgs;
                }
                else args[key] = valueArgs;
            });

            var url = "../" + srcArgs.url;
            commonFunc.getMethod(url, args).then((responseData) => {
                var dataRes = responseData.data;
                if (dataRes.isSuccess) {
                    //console.debug(dataRes.result);

                    var temp = dataRes.result;
                    if (dataRes.result && dataRes.result[0]?.refName) {
                        temp = dataRes.result?.map((elem) => {//TEMP
                            //elem.objective = 2000;
                            //elem.altValue = 15;
                            //elem.prevValue = 1800;

                            if (dataRes.extraInfo?.length) {
                                var temp3 = dataRes.extraInfo.filter((extra) => {
                                    return extra.period.split("-")[1] === elem.period.split("-")[1] && extra.refName === elem.refName;
                                });
                                if (temp3.length) {
                                    elem.prevValue = temp3[0].totalValue;
                                }
                                else {
                                    elem.prevValue = 0;
                                }
                            }

                            return elem;
                        }) || [];



                        if (srcArgs.cConversion === "ETP") {
                            dataRes.result?.forEach(dataItem => {
                                if (dataItem.totalValue && !dataItem.hours) {
                                    dataItem.hours = dataItem.totalValue;
                                    dataItem.totalValue = dataItem.hours / 151.76;
                                }
                                if (dataItem.prevValue && (!dataItem.prevHours || dataItem.prevHours === dataItem.prevValue)) {
                                    dataItem.prevHours = dataItem.prevValue;
                                    dataItem.prevValue = dataItem.prevHours / 151.76;
                                }
                            });
                        }

                        if (data.onActionEvents && data.onActionEvents["onRefresh"]) {
                            data.onActionEvents["onRefresh"].forEach((args, index) => {
                                modelFctManager.onActionRequired(data.name, args, data, { value: temp }).then(actionResponse => {
                                    //console.debug("RESPONSE");
                                    //console.debug(actionResponse);
                                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: actionResponse.errorMessage
                                        });
                                    }
                                    else {
                                        loadData(temp);
                                    }
                                });
                            });
                        }
                    }
                    else {
                        loadData(temp);
                    }

                } else {
                    /*Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });*/
                }
            });
        }
        else if (srcArgs?.cacheTarget) {
            var dataCache = modelFctManager.rootCache[srcArgs?.cacheTarget];
            if (dataCache) {
                var dataExtraCache = modelFctManager.rootCache["extra" + srcArgs?.cacheTarget];
                //console.debug(dataExtraCache);

                //TODO : voir pour les variations de groupement
                //if (dataExtraCache) {
                if (srcArgs.cacheTarget === "STATSLIST_GROUP_MY") {
                    var sumObj = {};
                    dataCache.forEach((elem) => {
                        if (!sumObj[elem.refName]) {
                            sumObj[elem.refName] = { name: elem.name, period: elem.period, refName: elem.refName, totalValue: 0 };
                        }
                        sumObj[elem.refName].period = elem.period;
                        sumObj[elem.refName].totalValue += elem.totalValue;
                    });
                    var newCache = Object.keys(sumObj).map((key) => {
                        var elem = sumObj[key];
                        if (dataExtraCache) {
                            var periodDate = moment(elem.period.split("-")[1], "YYYY-MM");
                            var cumulValue = 0;
                            dataExtraCache.forEach((extra) => {
                                var cumulDate = moment(extra.period.split("-")[1], "YYYY-MM")
                                if (cumulDate.isSameOrBefore(periodDate) && extra.refName === elem.refName) {
                                    cumulValue += extra.totalValue;
                                }
                            });
                            elem.prevValue = cumulValue;
                        }
                        return elem;
                    });
                    dataCache = newCache;
                }
                else {
                    dataCache = dataCache.map((elem) => {
                        if (dataExtraCache) {
                            var temp3 = dataExtraCache.filter((extra) => {
                                return extra.period.split("-")[1] === elem.period.split("-")[1] && extra.refName === elem.refName;
                            });
                            if (temp3.length) {
                                elem.prevValue = temp3[0].totalValue;
                            }
                            else {
                                elem.prevValue = 0;
                            }
                        }
                        return elem;
                    });
                }
                //}


                //Conversion des heures en ETP
                if (srcArgs.cConversion === "ETP") {
                    dataCache.forEach(dataItem => {
                        if (dataItem.totalValue && !dataItem.hours) {
                            dataItem.hours = dataItem.totalValue;
                            dataItem.totalValue = dataItem.hours / 151.76;
                        }
                        if (dataItem.prevValue && (!dataItem.prevHours || dataItem.prevHours === dataItem.prevValue)) {
                            dataItem.prevHours = dataItem.prevValue;
                            dataItem.prevValue = dataItem.prevHours / 151.76;
                        }
                    });
                }

                var orgRows = dataCache;

                if (srcArgs?.filter) {
                    srcArgs.filter.forEach(flr => {
                        var splitFlr = flr.split(":");
                        dataCache = dataCache.filter((elem) => {
                            var valueFilter = splitFlr[1];
                            if (splitFlr[1] === "selectFilter") {
                                if (!commonFunc.isBlank(selectFilter)) {
                                    valueFilter = selectFilter;
                                }
                                else {
                                    return true;
                                }
                            }
                            return elem[splitFlr[0]] === valueFilter;
                        });
                    });
                    //console.debug("FILTERED");
                    //console.debug(dataCache);
                }
                loadData(dataCache, orgRows);
            }
        }
    }

    function loadData(rows, orgRows) {
        var pile = {};
        var pileLabels = {};
        var pileTargets = data.argumentsObj?.pileTargets || [];
        var config = data.argumentsObj?.configsFromData;
        if (config && !Array.isArray(config)) config = [config];

        var sortedRows = rows;
        if (pileTargets?.length && pileTargets[0].key === "labels") sortedRows = sortedRows.sort((a, b) => a[pileTargets[0].target]?.localeCompare(b[pileTargets[0].target]));

        var outRows = sortedRows;

        if (data.argumentsObj?.groupTag) {
            var joinTags = data.argumentsObj.groupTag.split(";");

            var grouped = sortedRows.reduce((acc, item) => {
                var currGroupTag = joinTags.map(i => item[i]).join(";");
                if (!acc[currGroupTag]) {
                    acc[currGroupTag] = Object.assign({}, item);
                }
                else {
                    acc[currGroupTag].totalValue += item.totalValue;
                    if (item.ca_1) acc[currGroupTag].ca_1 = (parseFloat(acc[currGroupTag].ca_1) || 0) + parseFloat(item.ca_1);
                    if (item.ca_2) acc[currGroupTag].ca_2 = (parseFloat(acc[currGroupTag].ca_2) || 0) + parseFloat(item.ca_2);
                    if (item.ca_3) acc[currGroupTag].ca_3 = (parseFloat(acc[currGroupTag].ca_3) || 0) + parseFloat(item.ca_3);
                    if (item.ca_4) acc[currGroupTag].ca_4 = (parseFloat(acc[currGroupTag].ca_4) || 0) + parseFloat(item.ca_4);
                    if (item.ca_5) acc[currGroupTag].ca_5 = (parseFloat(acc[currGroupTag].ca_5) || 0) + parseFloat(item.ca_5);
                }
                return acc;
            }, {});

            outRows = Object.values(grouped);
        }

        outRows.forEach((elem, index) => {
            pileTargets.forEach((pileObj) => {
                if (!pileObj.cMergeLabels || !pileLabels[elem[pileObj.target]]) {
                    pileLabels[elem[pileObj.target]] = true;
                    if (!pile[pileObj.key]) pile[pileObj.key] = [];
                    pile[pileObj.key].push(formatData(elem[pileObj.target], pileObj.format));
                }
            });
            if (config?.length) {
                config.forEach((cfg => {
                    var pileKey = cfg.pileKey.split(";").map((key) => commonFunc.camelize(elem[key] || "null", true)).join(";");
                    if (!pile[pileKey]) pile[pileKey] = [];
                    pile[pileKey].push(formatData(elem[cfg.pileTarget], cfg.format));
                }));
            }
        });

        if (data.argumentsObj?.cReplaceLabels) {
            pile.labels.forEach((label, index) => {
                if (data.argumentsObj?.cReplaceLabels[label]) pile.labels[index] = data.argumentsObj?.cReplaceLabels[label];
            });
        }

        var datasets = [];
        if (config?.length) {
            var datasetsCheck = {};
            config.forEach(cfg => {
                var rowTab = outRows.map((elem, index) => {
                    var ds = { ...cfg };
                    ds.cTarget = cfg.pileKey.split(";").map((key) => commonFunc.camelize(elem[key] || "", true)).join(";");

                    if (!datasetsCheck[ds.cTarget]) {
                        datasetsCheck[ds.cTarget] = true;

                        if (ds.fill?.target?.cTarget) ds.fill.target.value = elem[ds.fill.target.cTarget];

                        if (cfg.cLabel) ds.label = elem[cfg.cLabel];
                        if (cfg.cColor) ds.cColor = elem[cfg.cColor];
                        if (cfg.cBorderColor) ds.cBorderColor = elem[cfg.cBorderColor];
                        if (cfg.cBackgroundColor) ds.cBackgroundColor = elem[cfg.cBackgroundColor];
                        return ds;
                    }
                    else {
                        return null;
                    }
                }).filter(elem => (elem != null));
                datasets.push(...rowTab);
            });
        }
        else {
            datasets = data.argumentsObj?.datasets;
        }

        var slicerValue = data.argumentsObj?.labelsSlice ? data.argumentsObj?.labelsSlice : 20;

        setAltData({
            labels: pile.labels?.map(label => (label.length > slicerValue ? (label.slice(0, slicerValue) + ".") : label)),
            datasets: datasets.map(dataset => {
                dataset.data = pile[dataset.cTarget];
                return dataset;
            }),
            cOrgRows: (orgRows || outRows)
        });
        if (!commonFunc.isBlank(selectFilter) && (pile.labels?.length <= 0 || datasets?.length <= 0)) setSelectFilter(null);
    }

    function formatData(data, format) {
        var value = data;
        switch (format) {
            case "date":
                //moment(data, "YYYY-MM").format("MMM YYYY");
                break;
            case "month":
                value = moment(data, "YYYY-MM").format("MMM YYYY");
                break;
            default:
                break;
        }
        return value;
    }

    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin && (!minDate || begin.isSameOrAfter(minDate))) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function datepickerChange(date) {
        if (!date) date = moment(curDate);

        setCurDate(date.format());
    }

    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin && (!maxDate || begin.isSameOrBefore(maxDate))) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function getFormattedDate() {
        if (curDate) {
            switch (curPeriod) {
                case "D": return moment(curDate).format("dddd DD MMMM YYYY");
                case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
                case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
                case "M": return moment(curDate).startOf('month').format("MMMM YYYY");
                case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
                default: return "";
            }
        }
        else {
            return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_chart");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) btnStyle.height = design.height;
            else {
                frameClass += " h-100 d-flex flex-column";
                btnStyle.height = "100%";
                btnStyle.position = "relative";
                btnStyle.flexGrow = 1;
                btnStyle.minHeight = 0;
                fullHeight = true;
            }
        }
        if (design.width) btnStyle.width = design.width;

        if (design.margin) {
            btnStyle.margin = design.margin;
            btnClass = btnClass.replace("m-1", "");
        }
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                btnStyle.marginTop = design.marginTop;
            }
            else {
                btnSupClass += design.marginTop;
            }
        }

        if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));
    }

    var chartOptions = JSON.parse(JSON.stringify(data.argumentsObj?.chartOptions));

    var labelSuffix = chartOptions.plugins?.tooltip?.callbacks?.cLabelSuffix;

    //Gestion de l'affichage tooltip si formattage
    const formatLabel = (tooltipItem, dataItem) => {
        return formatData(tooltipItem.dataset.label, data.argumentsObj?.chartOptions?.plugins?.tooltip?.callbacks?.label) + " : " + tooltipItem.formattedValue + (labelSuffix ? labelSuffix : "");
    };
    if (chartOptions.plugins?.tooltip?.callbacks?.label) {
        chartOptions.plugins.tooltip.callbacks.label = formatLabel;
    }

    //Gestion de l'affichage legend si formattage
    const formatLegendDateY = (chart) => {
        const dataChart = chart.data;
        return dataChart.datasets.map(function (ds, index) {
            return {
                text: formatData(ds.label, data.argumentsObj?.chartOptions?.plugins?.legend?.labels?.generateLabels),
                fillStyle: ds.backgroundColor,
                strokeStyle: ds.borderColor,
                hidden: false,
                index: index
            };
        });
    };
    if (chartOptions.plugins?.legend?.labels?.generateLabels) {
        chartOptions.plugins.legend.labels.generateLabels = formatLegendDateY;
    }
    if (chartOptions.plugins?.legend?.labels?.filter) {
        chartOptions.plugins.legend.labels.filter = (legendItem) => { return data.argumentsObj?.chartOptions?.plugins?.legend?.labels?.filter.indexOf(legendItem.text) < 0 };
    }

    //Gestion de l'affichage footer tooltip si présent
    const sumFooter = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!chartOptions.plugins?.tooltip?.callbacks?.footerFilter || chartOptions.plugins.tooltip.callbacks.footerFilter.indexOf(tooltipItem.dataset.cTarget) >= 0) {
                sum += parseFloat(tooltipItem.raw);
            }
        });
        return (chartOptions.plugins?.tooltip?.callbacks?.footerLabel ? chartOptions.plugins.tooltip.callbacks.footerLabel : 'Somme') + ' : ' + sum.toFixed(2);
    };
    const sumFooterX = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!chartOptions.plugins?.tooltip?.callbacks?.footerFilter || chartOptions.plugins.tooltip.callbacks.footerFilter.indexOf(tooltipItem.dataset.cTarget) >= 0) {
                sum += parseFloat(tooltipItem.raw);
            }
        });
        return (chartOptions.plugins?.tooltip?.callbacks?.footerLabel ? chartOptions.plugins.tooltip.callbacks.footerLabel : 'Somme') + ' : ' + sum.toFixed(2);
    };
    const difFooterClassic = (tooltipItems) => {
        var dif = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) dif -= tooltipItem.raw;
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif.toFixed(2);
    };
    const difFooter = (tooltipItems) => {
        var dif = 0;
        var difPct = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) {
                    difPct = (((dif - tooltipItem.raw) / tooltipItem.raw) * 100).toFixed(2);
                    dif -= tooltipItem.raw;
                }
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif?.toFixed(2) + '\nÉcart (%) : ' + (difPct > 100 ? 100: difPct) + ' %';
    };
    const difFooterReverse = (tooltipItems) => {
        var dif = 0;

        tooltipItems.reverse().forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) dif -= tooltipItem.raw;
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif.toFixed(2);
    };
    const difFooterReversePct = (tooltipItems) => {
        var dif = 0;
        var difPct = 0;

        tooltipItems.reverse().forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) {
                    difPct = (((dif - tooltipItem.raw) / tooltipItem.raw) * 100).toFixed(2);
                    dif -= tooltipItem.raw;
                }
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif?.toFixed(2) + '\nÉcart (%) : ' + (difPct > 100 ? 100 : difPct) + ' %';
    };
    if (chartOptions.plugins?.tooltip?.callbacks?.footer) {
        switch (chartOptions.plugins?.tooltip?.callbacks?.footer) {
            case "sumFooter": chartOptions.plugins.tooltip.callbacks.footer = sumFooter; break;
            case "sumFooterX": chartOptions.plugins.tooltip.callbacks.footer = sumFooterX; break;
            case "difFooterClassic": chartOptions.plugins.tooltip.callbacks.footer = difFooterClassic; break;
            case "difFooter": chartOptions.plugins.tooltip.callbacks.footer = difFooter; break;
            case "difFooterReverse": chartOptions.plugins.tooltip.callbacks.footer = difFooterReverse; break;
            case "difFooterReversePct": chartOptions.plugins.tooltip.callbacks.footer = difFooterReversePct; break;
            default: break;
        }
    }

    var selectFilterCpt = "";
    if (data.argumentsObj?.loadObj?.cSelectFilter) {
        var optsList = [];
        var filterSelectOpts = data.argumentsObj.loadObj.cSelectFilter;
        selectFilterCpt = <Input className={`d-inline-block w-auto float-end ${commonFunc.isBlank(selectFilter) ? "d-none" : ""}`} type="select" onChange={(e) => {
            setSelectFilter(e.target.value);
        }}>
            {(() => {
                var filteringRows;
                if (filterSelectOpts.fields === "sysLabels") {
                    filteringRows = altData?.labels;
                    if (filterSelectOpts.sort) filteringRows = filteringRows?.sort((a, b) => a[filterSelectOpts.fields].localeCompare(b[filterSelectOpts.fields]))
                    return filteringRows?.map((label, index) => {
                        return <option key={"opt" + label + index} value={label}>{label}</option>;
                    });
                }
                else {
                    filteringRows = altData?.cOrgRows;
                    if (filterSelectOpts.sort) filteringRows = filteringRows?.sort((a, b) => a[filterSelectOpts.fields].localeCompare(b[filterSelectOpts.fields]));
                    return filteringRows?.map((row, index) => {//altData?.datasets?
                        var val = row[filterSelectOpts.fields];
                        if (optsList.indexOf(val) < 0) {
                            if (commonFunc.isBlank(selectFilter) && optsList.length === 1) setSelectFilter(optsList[0]);
                            optsList.push(val);
                            return <option key={"opt" + val + index} value={val}>{val}</option>;
                        }
                        else {
                            return null;
                        }
                    }).filter(row => row !== null);
                }
            })()}
        </Input>;
    }


    var baseForm = <>
        {data.argumentsObj?.toolbarDateConfig ?
            <ToolbarDate refreshContent={() => { setRefreshData(!refreshData); } } customTitle={getFormattedDate()}
                currentPeriod={curPeriod} updatePeriod={data.argumentsObj.toolbarDateConfig.updatePeriod === true ? setCurPeriod : false}
                dateLink={curDate}
                selPreviousPeriod={selPreviousPeriod}
                datepickerChange={datepickerChange}
                selNextPeriod={selNextPeriod}
                datepickerOpt={{ showWeeks: true, initialValue: (curDate ? moment(curDate).utc().toDate() : moment().format()), minDate: minDate?.toDate(), maxDate: maxDate?.toDate() }}
                customAddBtn={<div className="d-none"></div>}
                statusContainer={selectFilterCpt}
                cPeriods={data.argumentsObj.toolbarDateConfig.periods}></ToolbarDate>
            : <div><Button className="btn btn-simple btn-rotate btn-dark btn-sm px-2 mt-0 mb-0" onClick={() => { setRefreshData(!refreshData); }}><i className="fa fa-sync"></i>{t("gal_refresh")}</Button>
                {!commonFunc.isBlank(selectFilterCpt) ? selectFilterCpt : ""}</div>}
        <div className={/*fullHeight ? "h-100" : */""} style={fullHeight ? { flex: "auto", height: (!fullHeight ? "" : "calc(100% - 30px)") } : {} }>
            <CChart type={data.subType || "line"} /*redraw*/
                className="d-inline-block align-top" unusedclass={`${btnClass} ${btnSupClass}`}
                style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null}
                data={altData}
                options={chartOptions} />
        </div>
    </>;


    return <Col data-name="ChartFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}